import React from 'react';

export const SkillRowExpandSvg = (props) => {

  const { expanded, onClick, width, height } = props;
  if (expanded) {
    return (
      <svg className="cursor-pointer" onClick={onClick} width={width ?? "34"} height={height ?? "34"} viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
          <rect width="30" height="30" rx="15" transform="matrix(1 0 0 -1 2 31)" fill="white" />
          <rect x="0.5" y="-0.5" width="29" height="29" rx="14.5" transform="matrix(1 0 0 -1 2 30)" stroke={window?.settings?.secondary_color ?? "#04333B"} />
        </g>
        <path d="M13.8352 17.7737C13.5452 18.0737 13.0752 18.0737 12.7752 17.7837C12.6252 17.6337 12.5552 17.4437 12.5552 17.2437C12.5552 17.0537 12.6252 16.8637 12.7752 16.7237L16.2452 13.2337C16.3852 13.0937 16.5752 13.0137 16.7752 13.0137C16.9752 13.0137 17.1652 13.0937 17.3052 13.2337L20.7752 16.7237C21.0752 17.0137 21.0752 17.4837 20.7752 17.7837C20.4852 18.0737 20.0052 18.0737 19.7152 17.7737L16.7752 14.8237L13.8352 17.7737Z" fill={window?.settings?.secondary_color ?? "#04333B"} />
      </svg>

    )
  }
  return (
    <svg className="cursor-pointer" onClick={onClick} width={width ?? "34"} height={height ?? "34"} viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <rect width="30" height="30" rx="15" transform="matrix(-1 0 0 1 32 1)" fill="white" />
        <rect x="-0.5" y="0.5" width="29" height="29" rx="14.5" transform="matrix(-1 0 0 1 31 1)" stroke="#E3E3E3" />
      </g>
      <path d="M20.1648 14.2263C20.4548 13.9263 20.9248 13.9263 21.2248 14.2163C21.3748 14.3663 21.4448 14.5563 21.4448 14.7563C21.4448 14.9463 21.3748 15.1363 21.2248 15.2763L17.7548 18.7663C17.6148 18.9063 17.4248 18.9863 17.2248 18.9863C17.0248 18.9863 16.8348 18.9063 16.6948 18.7663L13.2248 15.2763C12.9248 14.9863 12.9248 14.5163 13.2248 14.2163C13.5148 13.9263 13.9948 13.9263 14.2848 14.2263L17.2248 17.1763L20.1648 14.2263Z" fill={window?.settings?.secondary_color ?? "#04333B"} />
    </svg>

  )
}